import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  labelColor?: string;
  style?: React.CSSProperties & { '--input-gap'?: string };
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, placeholder, value, error, labelColor = '#fff', style, ...props }, ref) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const hasValue = value && value.toString().length > 0;

    return (
      <div className="flex flex-col">
        {((type === 'date' && placeholder === 'Birthday') || isFocused || hasValue) && (
          <label className="text-xs" style={{ color: labelColor }}>
            {placeholder}
          </label>
        )}
        <input
          type={type}
          placeholder={!isFocused && !hasValue ? placeholder : ""}
          value={value}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={cn(
            "flex h-12 w-full box-border rounded-md px-3 py-2 text-base focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
            // Default styles (can be overridden by className)
            "border border-white bg-white/5 text-white placeholder:text-white/60",
            // Override with custom styles
            className,
            // Error state
            error && "border-red-500",
            // Date picker
            type === 'date' && "[&::-webkit-calendar-picker-indicator]:invert"
          )}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
